import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { Link as RLink } from "react-router-dom";
import Link from "@mui/material/Link";

import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { SerializedError } from "../../util/types";
import Metadata from "../metadata/Metadata";
import TimeObjectDisplay from "./TimeObjectDisplay";
import MDViewer from "../markdown/Markdown";
import { Ticket, selectTicket, selectChildrenItems } from "./ticketSlice";
import {
    useTicketViewQuery,
    useCopyMutation,
    TicketItemsResponse,
} from "../../api/ticket";

export default function TicketDisplay({ ticket }: { ticket: Ticket }) {
    const navigate = useNavigate();
    const [copyTicket, { isLoading: isUpdating }] = useCopyMutation();
    const onCopy = () => {
        if (ticket.metadata.id) {
            copyTicket(ticket.metadata.id)
                .unwrap()
                .then((fullfilled) => {
                    if (fullfilled && fullfilled.ticket) {
                        navigate(
                            "/ticket/view/" + fullfilled.ticket.metadata.id,
                        );
                    }
                });
        }
    };
    const onDuplicate = () => {
        if (ticket.metadata.id) {
            copyTicket(ticket.metadata.id)
                .unwrap()
                .then((fullfilled) => {
                    if (fullfilled && fullfilled.ticket) {
                        navigate("/ticket/edit/" + ticket.metadata.id);
                    }
                });
        }
    };

    return (
        <Box>
            <Typography variant="title">{ticket.title}</Typography>
            <Grid container spacing={2}>
                <Grid size={4}>
                    <Metadata meta={ticket.metadata} />
                </Grid>
                <Grid size={4}>
                    <TimeObjectDisplay tod={ticket.time} onChange={() => {}} />
                </Grid>
                <Grid size={4}>
                    <Link
                        component={RLink}
                        to={"/ticket/view/" + ticket.metadata.id}
                    >
                        View
                    </Link>
                    <br /> -
                    <Link
                        component={RLink}
                        to={"/ticket/edit/" + ticket.metadata.id}
                    >
                        Edit
                    </Link>
                    <br />-<Button onClick={onCopy}>Copy</Button>
                    <br />-<Button onClick={onDuplicate}>Duplicate</Button>
                    <br />
                    type:{ticket.ktype}
                    <br />
                    parent:{" "}
                    <Link
                        component={RLink}
                        to={"/ticket/view/" + ticket.parent_id}
                    >
                        {ticket.parent_id}
                    </Link>
                    <br />
                    context:{" "}
                    <Link
                        component={RLink}
                        to={"/ticket/byContext/" + ticket.context_id}
                    >
                        {ticket.context_id}
                    </Link>
                    <br />
                </Grid>
                <Grid size={12}>
                    <MDViewer md={ticket.content.content} />
                </Grid>
            </Grid>
        </Box>
    );
}
